import { createFileRoute } from '@tanstack/react-router'
import EventManagement from '@/components/protected/event/EventManagement'
import AdminSidebar from '@/components/layout/AdminSidebar'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import PageLayout from '@/components/layout/PageLayout'

export const Route = createFileRoute('/_protected/event')({
    component: () => (
        <ProtectedRoute>
            <PageLayout>
                <div className="flex h-screen">
                    <AdminSidebar />
                    <main className="flex-1 overflow-auto">
                        <EventManagement />
                    </main>
                </div>
            </PageLayout>
        </ProtectedRoute>
    ),
})
